import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/workforce')({ component: WorkforceLayout });

/** Nessun chrome di rotta: ogni pagina sotto `/workforce` ha la sua testata. */
function WorkforceLayout() {
  return <Outlet />;
}
